// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";
import {WebServices} from "../../../../recursos/modelo/consumerModel/web-services.enum";
import {ConsumerService} from "../../../../recursos/servicio/consumer.service";
import {LayoutService} from "../../../../recursos/servicio/layout.service";
// ITEM QUE SE DEBE MODIFICAR PARA LOS CRUD
declare const $: any;

declare var swal: any;
declare let d3: any;

@Component({
    selector: 'app-gestion',
    templateUrl: './view/gestion.component.html',
    styleUrls: ['./css/gestion.component.css'],
    providers: [ConsumerService]

})


export class IndicadoresGestionComponent implements OnInit {

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─

    // variables de pantalla
    public usuarioSession: any;
    emisor: any = {};
    emisores: any[];
    empresaAdministradora = false;
    mensaje;
    loading = false;
    noHayResultados = false;

    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_LOG_LISTAR: false,
        ROLE_LOG_CONSULTAR: false,
        ROLE_LOG_REGISTRAR: false,
        ROLE_LOG_MODIFICAR: false,
        ROLE_LOG_ELIMINAR: false,
        ROLE_LOG_ACTIVAR: false,
    };

    cargandoVentaDetalleProducto: boolean = false;
    cargandoVentaDetalleCliente: boolean = false;

    cargandoCompraDetalleProducto: boolean = false;
    cargandoCompraDetalleProveedores: boolean = false;

    cargandoCompraVentaDetalle: boolean = false;
    totalOperaciones: number;
    totalMonto: number;
    promedioMontoDia: number;
    promedioMontoOperaciones: number;


    colorScheme = {
        domain: ['#ff0c15', '#002ea4', '#ff9900', '#09a40b', '#00aa83']
    };

    DATA_VENTA_PRODUCTOS: any = null;
    DATA_VENTA_CLIENTES: any = null;


    DATA_COMPRA_PRODUCTOS: any = null;
    DATA_COMPRA_PROVEEDORES: any = null;

    opcion: string;
    moneda: string;
    rangeDates: Date[];
    locale = 'es';
    colorTheme = 'theme-dark-blue';
    bsConfig: Partial<BsDatepickerConfig>;

    linePlusBarWithFocusChart: any;

    linePlusBarWithFocusChart_DATA: any;

    public colorTitle = null;

    constructor(private consumer: ConsumerService,
                private route: ActivatedRoute,
                private layout: LayoutService,
                private router: Router,
                public jwtUtil: UtilConfig,
                private _localeService: BsLocaleService) {

        this.usuarioSession = jwtUtil.getCurrentUser();
        this._localeService.use(this.locale);
        this.bsConfig = Object.assign({}, {containerClass: this.colorTheme, showWeekNumbers: false});
        var fechaIni = (new Date().getMonth() + 1) + "/01/" + new Date().getFullYear();
        this.rangeDates = [new Date(fechaIni), new Date()];

        // SI LA EMPRESA ES ESCON SE HABILITAN LOS SELECT
        if (jwtUtil.getCurrentUser().customer.id == jwtUtil.ESCON_CUSTOMER) {
            this.emisor = {label: 'Todos los contribuyentes', value: "-1"};
            this.empresaAdministradora = true;
        } else if (this.usuarioSession.customer.type == 'CANAL' || this.usuarioSession.customer.type == 'MULTI_EMPRESA') {
            this.emisor = {label: 'Todos los contribuyentes', value: "-1"};
        } else {
            this.emisor = {
                value: jwtUtil.getCurrentUser().customer.id,
                label: jwtUtil.getCurrentUser().customer.nombre
            };
        }

        this.emisores = [];
        this.emisores.push({label: 'Todos los contribuyentes', value: "-1"});
        this.consultarCombos();
        // VERIFICA LOS PERMISOS DEL LOG LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);

        this.moneda = "SOLES";
        this.opcion = "VENTAS";

        this.linePlusBarWithFocusChart = {
            chart: {
                type: 'linePlusBarChart',
                height: 400,
                margin: {
                    top: 30,
                    right: 75,
                    bottom: 50,
                    left: 75

                },
                useInteractiveGuideline: true,
                color: ['#2ca02c', '#741113'],
                xAxis: {
                    axisLabel: 'Fecha',
                    tickFormat: function (d) {
                        return d3.time.format('%d/%m/%Y')(new Date(d));
                    }
                },
                x2Axis: {
                    tickFormat: function (d) {
                        return d3.time.format('%d/%m/%Y')(new Date(d));
                    },
                },
                y1Axis: {
                    axisLabel: 'Operaciones',
                    tickFormat: function (d) {
                        return d3.format(',f')(d);
                    },
                    axisLabelDistance: 12
                },
                y2Axis: {
                    axisLabel: 'Total',
                    tickFormat: function (d) {
                        return '$' + d3.format(',.2f')(d)
                    }
                },
                y3Axis: {
                    tickFormat: function (d) {
                        return 'Total operaciones: ' + d3.format(',f')(d);
                    }
                },
                y4Axis: {
                    tickFormat: function (d) {
                        return '$' + d3.format(',.2f')(d)
                    }
                }
            }
        };

        if (this.jwtUtil.getColorTitle()) {
            this.colorTitle = this.jwtUtil.getColorTitle();
        }

    }

    ngOnInit() {
        this.calcular();

        //let timer = Observable.timer(1000, 20000);
        //let subscription = timer.subscribe(x =>
        //    this.calcularBackground()
        //);
    }

    calcularBackground() {
        this.consultarCompraVenta(false);
        this.consultarVentasProducto(false);
        this.consultarVentasClientes(false);
        this.consultarComprasProducto(false);
        this.consultarComprasProveedores(false);
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴

    help() {
    }

    calcular() {
        this.consultarCompraVenta();
        this.consultarVentasProducto();
        this.consultarVentasClientes();
        this.consultarComprasProducto();
        this.consultarComprasProveedores();
    }


    onSelect(event) {
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘


    consultarCombos() {
        // LLAMADO AL SERVICIO

        if (this.usuarioSession.customer.type == 'GENERAL')
            this.consumer.post(WebServices.URL_GET_COMBOS_LOG_EMISOR)
                .subscribe(result => {
                    this.emisores = [];
                    if (this.empresaAdministradora)
                        this.emisores.push({label: 'Todos los contribuyentes', value: "-1"});
                    $.each(result["comboCustomers"], (pos, item) => {
                        if (this.empresaAdministradora) {
                            this.emisores.push({label: item.value, value: item.key});
                        } else {
                            if (item.key == this.emisor) {
                                this.emisores.push({label: item.value, value: item.key});
                            }
                        }
                    });
                }, err => {
                    this.jwtUtil.manejoError(err, this.router);
                });
        else {
            this.consumer.post<any>(WebServices.URL_GET_AFFILIATES, {customer: {id: this.usuarioSession.customer.id}})
                .subscribe((result) => {
                    this.emisores = [];
                    this.emisores.push({label: 'Todos los contribuyentes', value: "-1"});

                    if (result["affiliates"] != null) {
                        $.each(result["affiliates"], (pos, item) => {
                            this.emisores.push({label: item.nombre, value: item.id});
                        });
                    }
                }, err => {
                    this.jwtUtil.manejoError(err, this.router);
                });
        }
    }

    /* COMPRA Y VENTA */

    public togglesOperacion(operacion) {
        this.opcion = operacion;
        this.consultarCompraVenta();
    }

    public togglesMoneda(moneda) {
        this.moneda = moneda;
        this.consultarCompraVenta();
    }

    cambiarEmisor(em) {
        this.emisor = em;
        this.calcular();
    }

    /* VENTAS */

    private consultarCompraVenta(cargando = true) {
        // LLAMADO AL SERVICIOROLE_REPORTE_OPERACIONES_AUDITORIA_NO_SALGA

        if (cargando)
            this.cargandoCompraVentaDetalle = true;
        let param = {
            ruc: this.emisor.value,
            fechaDesde: this.rangeDates[0],
            fechaHasta: this.rangeDates[1],
            operacion: this.opcion,
            moneda: this.moneda
        };
        this.consumer.post(WebServices.URL_DASHBOARD_COMPRA_VENTA, param)
            .subscribe(result => {

                if (result["codigo"] == 1) {
                    this.linePlusBarWithFocusChart_DATA = result["dashboard"].map((series: any, pos) => {
                        if (pos == 0)
                            series.bar = true;
                        series.values = series.values.map(function (d) {
                            let serie: any = {};
                            serie.x = new Date(d.x);
                            serie.y = d.y;
                            return serie;
                        });

                        if (pos == 1) {
                            this.totalMonto = series.totalMonto;
                            this.totalOperaciones = series.totalOperaciones;
                            this.promedioMontoDia = series.promedioMontoDia;
                            this.promedioMontoOperaciones = series.promedioMontoOperaciones;
                        }
                        return series;
                    });

                }
                if (cargando)
                    this.cargandoCompraVentaDetalle = false;
            }, err => {
                if (cargando)
                    this.cargandoCompraVentaDetalle = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo obtener los dashboard de compra y venta", this.router)
            });
    }

    // VENTAS PRODUCTOS
    private consultarVentasProducto(cargando = true) {
        // LLAMADO AL SERVICIO

        if (cargando)
            this.cargandoVentaDetalleProducto = true;
        let param = {
            ruc: this.emisor.value,
            fechaDesde: this.rangeDates[0],
            fechaHasta: this.rangeDates[1]
        };
        this.consumer.post(WebServices.URL_DASHBOARD_VENTAS_PRODUCTOS, param)
            .subscribe(result => {
                this.DATA_VENTA_PRODUCTOS = [];
                if (result["totales"])
                    $.each(result["totales"].values, (pos, item) => {
                        this.DATA_VENTA_PRODUCTOS.push({
                            "name": item.x,
                            "value": item.y
                        });
                    });
                if (cargando)
                    this.cargandoVentaDetalleProducto = false;
            }, err => {
                if (cargando) {
                    this.cargandoVentaDetalleProducto = false;
                    this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo obtener los dashboard de venta de productos", this.router)
                }
            });
    }


    /* COMPRAS */

    // VENTAS CLIENTES
    private consultarVentasClientes(cargando = true) {
        // LLAMADO AL SERVICIO
        if (cargando)
            this.cargandoVentaDetalleCliente = true;
        let param = {
            ruc: this.emisor.value,
            fechaDesde: this.rangeDates[0],
            fechaHasta: this.rangeDates[1]
        };
        this.consumer.post(WebServices.URL_DASHBOARD_VENTAS_CLIENTES, param)
            .subscribe(result => {
                this.DATA_VENTA_CLIENTES = [];
                if (result["totales"])
                    $.each(result["totales"].values, (pos, item) => {
                        this.DATA_VENTA_CLIENTES.push({
                            "name": item.x,
                            "value": item.y
                        });
                    });
                if (cargando)
                    this.cargandoVentaDetalleCliente = false;
            }, err => {
                if (cargando) {
                    this.cargandoVentaDetalleCliente = false;
                    this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo obtener los dashboard de venta de clientes", this.router)
                }
            });
    }

    // COMPRAS PRODUCTOS
    private consultarComprasProducto(cargando = true) {
        // LLAMADO AL SERVICIO
        if (cargando)
            this.cargandoCompraDetalleProducto = true;
        let param = {
            ruc: this.emisor.value,
            fechaDesde: this.rangeDates[0],
            fechaHasta: this.rangeDates[1]
        };
        this.consumer.post(WebServices.URL_DASHBOARD_COMPRA_PRODUCTOS, param)
            .subscribe(result => {
                this.DATA_COMPRA_PRODUCTOS = [];
                if (result["totales"])
                    $.each(result["totales"].values, (pos, item) => {
                        this.DATA_COMPRA_PRODUCTOS.push({
                            "name": item.x,
                            "value": item.y
                        });
                    });
                if (cargando)
                    this.cargandoCompraDetalleProducto = false;
            }, err => {
                if (cargando) {
                    this.cargandoCompraDetalleProducto = false;
                    this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo obtener los dashboard de compra de productos", this.router)
                }
            });
    }

    // COMPRAS CLIENTES
    private consultarComprasProveedores(cargando = true) {
        // LLAMADO AL SERVICIO
        if (cargando)
            this.cargandoCompraDetalleProveedores = true;
        let param = {
            ruc: this.emisor.value,
            fechaDesde: this.rangeDates[0],
            fechaHasta: this.rangeDates[1]
        };
        this.consumer.post(WebServices.URL_DASHBOARD_COMPRA_PROVEEDORES, param)
            .subscribe(result => {
                this.DATA_COMPRA_PROVEEDORES = [];
                if (result["totales"])
                    $.each(result["totales"].values, (pos, item) => {
                        this.DATA_COMPRA_PROVEEDORES.push({
                            "name": item.x,
                            "value": item.y
                        });
                    });
                if (cargando)
                    this.cargandoCompraDetalleProveedores = false;
            }, err => {
                if (cargando) {
                    this.cargandoCompraDetalleProveedores = false;
                    this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo obtener los dashboard de compra a proveedores", this.router)
                }
            });
    }

}





// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/reporte/dashboard/gestion/gestion.component.ts